
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.333 9.1V4h2v5.1l-1-.933-1 .933zm3.334 1V1.333h2V8.1l-2 2zM2 12.4V6.667h2V10.4l-2 2zm0 1.633l4.3-4.3 2.367 2.034L12.4 8.033h-1.067V6.7h3.334v3.333h-1.334V8.967l-4.6 4.6-2.366-2.034-2.5 2.5H2z","fill":"currentColor"}})])
          )
        }
      }
    